import { render, staticRenderFns } from "./ApprovalQuestions.vue?vue&type=template&id=900e8052"
import script from "./ApprovalQuestions.vue?vue&type=script&lang=js"
export * from "./ApprovalQuestions.vue?vue&type=script&lang=js"
import style0 from "./ApprovalQuestions.vue?vue&type=style&index=0&id=900e8052&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports